<template>
  <div>
    <TemplateDescription @changed-description="reloadTemplates += 1" />
    <ExternalProfile :reload-templates="reloadTemplates" />
  </div>
</template>

<script>
import TemplateDescription from './TemplateDescription.vue';
import ExternalProfile from './ExternalProfile.vue';

export default {
  name: 'ProductionOffersTab',

  components: {
    TemplateDescription,
    ExternalProfile,
  },

  data() {
    return {
      reloadTemplates: 0,
    };
  },
};
</script>
